'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  object: 'block',
  type: 'table',
  data: {
    className: 'table_three'
  },
  nodes: [{
    object: 'block',
    type: 'table_row',
    nodes: [{
      object: 'block',
      type: 'table_cell',
      data: {
        header: true
      },
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Left'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      data: {
        header: true
      },
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Middle'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      data: {
        header: true
      },
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Right'
        }]
      }]
    }]
  }, {
    object: 'block',
    type: 'table_row',
    nodes: [{
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Left'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Middle'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Right'
        }]
      }]
    }]
  }, {
    object: 'block',
    type: 'table_row',
    nodes: [{
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Left'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Middle'
        }]
      }]
    }, {
      object: 'block',
      type: 'table_cell',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'Right'
        }]
      }]
    }]
  }]
};